import * as Yup from "yup";

export const feedbackFormValidationSchema = Yup.object({
  app: Yup.array()
    .of(
      Yup.object({
        name: Yup.string(),
        image: Yup.mixed().when("name", {
          is: (val: any) => val?.length > 0,
          then: (s) => s.required(),
        }),
      }).default(null)
    )
    .default([]),
  movie: Yup.array()
    .of(
      Yup.object({
        name: Yup.string(),
        image: Yup.mixed().when("name", {
          is: (val: any) => val?.length > 0,
          then: (s) => s.required(),
        }),
      }).default(null)
    )
    .default([]),
  youtube: Yup.array()
    .of(
      Yup.object({
        name: Yup.string(),
        image: Yup.mixed().when("name", {
          is: (val: any) => val?.length > 0,
          then: (s) => s.required(),
        }),
      }).default(null)
    )
    .default([]),
  podcast: Yup.array()
    .of(
      Yup.object({
        name: Yup.string(),
        image: Yup.mixed().when("name", {
          is: (val: any) => val?.length > 0,
          then: (s) => s.required(),
        }),
      }).default(null)
    )
    .default([]),
  book: Yup.array()
    .of(
      Yup.object({
        name: Yup.string(),
        image: Yup.mixed().when("name", {
          is: (val: any) => val?.length > 0,
          then: (s) => s.required(),
        }),
        author: Yup.string().when("name", {
          is: (val: any) => val?.length > 0,
          then: (s) => s.required(),
        }),
      }).default(null)
    )
    .default([]),
});
